import styled from 'styled-components';

import { ButtonLinkProps } from '@savgroup-front-common/core/atoms/button/ButtonLink/ButtonLink';
import { Link } from '@savgroup-front-common/core/atoms/link';
import { fontStyle } from '@savgroup-front-common/core/theme/helpers/fontStyle';
import { darken } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $BreadcrumbWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  max-width: 100%;
  margin-bottom: ${spacing('lg')};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  /*
   * Rounds the outer corners of the whole chevron bar: the chips keep square
   * clip-path corners, and this rounded box clips them back to the design
   * radius — so rounding survives regardless of how many chips are rendered.
   */
  overflow: hidden;
`;

export const $Breadcrumb = styled(Link)<
  { $active?: boolean } & ButtonLinkProps
>`
  --breadcrumb-arrow: ${spacing(3)};

  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  height: ${spacing('xl')};
  padding: 0 calc(var(--breadcrumb-arrow) + ${spacing(3)});
  ${fontStyle('xs')};
  white-space: nowrap;
  text-decoration: none;
  transition: background-color 0.1s ease-in-out;
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.white};
  background-color: ${({ theme, $active }) =>
    $active ? theme.systemColors.defaultBackground : theme.colors.primary};
  clip-path: polygon(
    0 0,
    calc(100% - var(--breadcrumb-arrow)) 0,
    100% 50%,
    calc(100% - var(--breadcrumb-arrow)) 100%,
    0 100%,
    var(--breadcrumb-arrow) 50%
  );

  & + & {
    margin-left: calc(var(--breadcrumb-arrow) * -1 + ${spacing('px')});
  }

  &:first-child {
    padding-left: ${spacing('lg')};
    clip-path: polygon(
      0 0,
      calc(100% - var(--breadcrumb-arrow)) 0,
      100% 50%,
      calc(100% - var(--breadcrumb-arrow)) 100%,
      0 100%
    );
  }

  &:last-child {
    padding-right: ${spacing('lg')};
    clip-path: polygon(
      0 0,
      100% 0,
      100% 100%,
      0 100%,
      var(--breadcrumb-arrow) 50%
    );
  }

  &:only-child {
    padding: 0 ${spacing('lg')};
    clip-path: none;
    border-radius: ${({ theme }) => theme.tw.radius.sm};
  }

  &:hover {
    text-decoration: none;
    color: ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.white};
    background-color: ${({ theme, $active }) =>
      $active
        ? theme.systemColors.defaultBackground
        : darken(0.05, theme.colors.primary)};
  }
`;
